
import { gallerySectionFive } from "data/gallerySection";
import useActive from "hooks/useActive";
import Link from "next/link";
import { Col, Image, Row } from "react-bootstrap";
import React, { useState } from "react";
import WeDOSectionStaffSol from "components/WeDOSection/WeDOSectionStaffSol";
import { useAppStore } from "lib/store";
import { Box, IconButton, ImageList, ImageListItem, ImageListItemBar } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';


interface Props {
    path?: string;
    title?: string
    count?: number
    alt?: string
}


const MansonryLoader = ({ path, count, title, alt }: Props) => {

    return (
        <ImageListItem key={`${title}${count}-img`} >
            <img
                srcSet={`${path}${title}${count}.jpg`}
                src={`${path}${title}${count}.jpg`}
                alt={alt}
                loading="lazy"
            />
            <ImageListItemBar
                title={alt}
                subtitle={`BGZA`}
                actionIcon={
                    <IconButton
                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                        aria-label={`info about ${`Staff-Solutions`}`}
                    >
                        <InfoIcon />
                    </IconButton>
                }
            />
        </ImageListItem>
    )
}

export default MansonryLoader;